import React from 'react';
import { useTranslatedContent } from '../../i18n/hooks/useTranslatedContent';

const ProductScreenshots = () => {
  const { t } = useTranslatedContent('scale365');

  return (
    <div className="bg-white/5 backdrop-blur-sm rounded-2xl p-8 border border-white/10">
      <h3 className="text-2xl font-semibold text-white mb-8">{t('dashboard.title')}</h3>
      
      <div className="relative group">
        <div className="absolute inset-0 bg-gradient-to-br from-blue-500/20 to-violet-500/20 rounded-xl transform rotate-3 group-hover:rotate-6 transition-transform duration-300"></div>
        <div className="relative bg-white/10 backdrop-blur-sm rounded-xl aspect-video overflow-hidden">
          <img
            src="https://images.unsplash.com/photo-1498050108023-c5249f4df085?ixlib=rb-1.2.1&auto=format&fit=crop&w=2700&q=80"
            alt="Enterprise Dashboard"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
        </div>
      </div>

      <p className="text-blue-200 text-center mt-8">
        {t('dashboard.description')}
      </p>
    </div>
  );
};

export default ProductScreenshots;